import { render } from "./TheAddConsumerGroup.vue?vue&type=template&id=4c02961e&scoped=true&ts=true"
import script from "./TheAddConsumerGroup.vue?vue&type=script&lang=ts"
export * from "./TheAddConsumerGroup.vue?vue&type=script&lang=ts"

import "./TheAddConsumerGroup.vue?vue&type=style&index=0&id=4c02961e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c02961e"]])

export default __exports__